import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/recommendation/manual-01_kv.gif'
import _imports_1 from '../../assets/recommendation/manual-01_img1.png'
import _imports_2 from '../../assets/recommendation/manual-01-android_img2.png'
import _imports_3 from '../../assets/recommendation/manual-01_img3.png'


const _hoisted_1 = {
  class: "main",
  id: "main"
}
const _hoisted_2 = { class: "wrap__manual" }
const _hoisted_3 = { class: "header__manual" }
const _hoisted_4 = { class: "section_inner__manual" }
const _hoisted_5 = { class: "section_wrapper__manual" }
const _hoisted_6 = { class: "section__manual section__list__manual section__list__manual--purple" }
const _hoisted_7 = { class: "contents__manual" }
const _hoisted_8 = { class: "section__manual section__list__manual section__list__manual--orange" }
const _hoisted_9 = { class: "contents__manual" }
const _hoisted_10 = { class: "section__manual section__list__manual section__list__manual--green" }
const _hoisted_11 = { class: "contents__manual" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "ttl__manual" }, "通信やテクノロジーにより暮らしが豊かになる情報をお届け!", -1)),
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              class: "img__header__manual",
              onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_0,
              alt: ""
            }, null, 32)
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text__manual" }, "【使い方サポート】をご利用いただきありがとうございます。お知らせで届くコンテンツには、あなたの興味に合ったヒントが数多く登場し、暮らしをサポートしていきます。その内容やお伝えする方法もさまざまにご用意。", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              class: "img__manual",
              onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_1,
              alt: ""
            }, null, 32)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "ttl__section___manual" }, "上手にスマホで撮影するなら基本の写真テク「三分割法」", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text__manual" }, "被写体を中央に置いてしまい、どこか味気ない写真に毎回なってしまう…。スマートフォンでも写真の基本はかわりません。一歩グレードアップさせるなら「三分割法」をマスターするのがおすすめです。", -1)),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "btn__manual",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoInteractive()))
              }, "記事を読む")
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              class: "img__manual",
              onLoad: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_2,
              alt: ""
            }, null, 32)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "ttl__section___manual" }, "片手でスイスイ操作できる！Android10 の「ジェスチャーナビゲーション」", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text__manual" }, "スマートフォンを片手だけで操作すると、画面サイズが思った以上に大きくて意外と大変。そんなときに助かる機能が Android10 にあります。「ジェスチャーナビゲーション」を試してみれば、片手でもラクラク操作…となるはずです。", -1)),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "btn__manual",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoSecondNotification()))
              }, "記事を読む")
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_10, [
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              class: "img__manual has-bgcolor",
              onLoad: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_3,
              alt: ""
            }, null, 32)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "ttl__section___manual" }, "スマホが医療機関との距離を近づける「オンライン診療」とは？", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text__manual" }, "スマートフォンはWEBを通じてさまざまな世界と簡単につながり、生活のお困りごとを解消してくれるのが便利なポイント！体調が少し悪いかな…というとき、おうち時間でお医者さんのオンライン診療を受けられるアプリサービスもあります。", -1)),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "btn__manual",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.gotoPage3()))
              }, "記事を読む")
            ])
          ])
        ])
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("section", { class: "footer__manual" }, [
        _createElementVNode("div", { class: "section_inner__manual" }, [
          _createElementVNode("h2", { class: "ttl__manual" }, "スマホの楽しさ、もっと広がる。"),
          _createElementVNode("p", null, "このように、これから始まる新しいスマートフォンとの生活をより楽しく、より快適にしてくれるヒントをさまざまな記事でご紹介していきます。【使い方サポート】がお届けするコンテンツの代表例をはじめ、あなたの暮らしがより快適になる今後の出会いにご期待ください。")
        ])
      ], -1))
    ])
  ]))
}